(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klaviyo-english-copy"] && !Shopify.designMode) return;
  try {
    (() => {
    const formSelector = '.klaviyo-form-XL84yx';
    const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
    const translations = new Map([
      ['10% de descuento en tu primera compra al suscribirte', 'Get 10% off your first order when you subscribe'],
      ['Únete a nuestra comunidad de flores y recibe un', 'Join our flower community and receive'],
      ['10% de descuento', '10% off'],
      ['en tu primera compra.', 'your first order.'],
      ['Suscribirme', 'Subscribe'],
      ['Este campo es obligatorio.', 'This field is required.'],
      ['Introduce una dirección de correo electrónico válida.', 'Enter a valid email address.'],
      ['Por favor, introduce una dirección de email válida.', 'Enter a valid email address.'],
      ['Gracias por suscribirte', 'Thank you for subscribing']
    ]);

    const demoteFormHeadings = (root) => {
      root.querySelectorAll('h1').forEach((heading) => {
        const replacement = document.createElement('h2');

        Array.from(heading.attributes).forEach((attribute) => {
          replacement.setAttribute(attribute.name, attribute.value);
        });
        while (heading.firstChild) replacement.appendChild(heading.firstChild);
        heading.replaceWith(replacement);
      });
    };

    const localizeTextNodes = (root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        const value = node.nodeValue || '';
        const trimmedValue = value.trim();
        const replacement = translations.get(trimmedValue);

        if (replacement) {
          const leadingSpace = value.match(/^\s*/)?.[0] || '';
          const trailingSpace = value.match(/\s*$/)?.[0] || '';
          node.nodeValue = `${leadingSpace}${replacement}${trailingSpace}`;
        }

        node = walker.nextNode();
      }
    };

    const attachLocalizer = () => {
      const root = document.querySelector(formSelector);
      if (!root) return false;

      demoteFormHeadings(root);
      if (isEnglish) localizeTextNodes(root);

      if (root.dataset.lmEnglishCopyReady !== 'true') {
        root.dataset.lmEnglishCopyReady = 'true';
        const formObserver = new MutationObserver(() => {
          demoteFormHeadings(root);
          if (isEnglish) localizeTextNodes(root);
        });
        formObserver.observe(root, { childList: true, subtree: true, characterData: true });
      }

      return true;
    };

    if (attachLocalizer()) return;

    const renderObserver = new MutationObserver(() => {
      if (attachLocalizer()) renderObserver.disconnect();
    });

    renderObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
